import { PropsWithChildren, ReactNode } from "react";
import { Container } from "react-bootstrap";

interface Props {
  title?: string | ReactNode;
}

function Title({ children }: PropsWithChildren<{}>) {
  return (
    <div className="d-flex justify-content-around">
      <h1 className="fw-light mb-0">{children}</h1>
    </div>
  );
}

export default function Header({ title, children }: PropsWithChildren<Props>) {
  return (
    <Container
      className="py-3 bg-surface-variant shadow-sm text-on-surface-variant text-center"
      style={{ minHeight: 80 }}
      fluid
    >
      {title && <Title>{title}</Title>}
      {children}
    </Container>
  );
}
